import * as navigate from 'app/area/shared/navigation';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import { api } from './api';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';

export const actionCreators = {

  duplicateCase: (caseId: number): ActionDispatching<any, ApplicationState> => 
    async (dispatch: any, getState: ()=> ApplicationState) => {
      try{
        const { utcOffset } = getState().app.settings;
        const draftId = await api.duplicateCase(caseId, {utcOffset});
        navigate.toDraft(draftId);
      }catch (err){
        dispatch(new ErrorNotification(err.userMessages || err.message));
        navigate.toCaseView(caseId);
      }
    }
};
